import React from "react";
import algoliasearch from "algoliasearch/lite";
import classNames from "classnames";
import { Configure, InstantSearch } from "react-instantsearch-dom";
import ReactTooltip from "react-tooltip";
import Header from "../components/Header";
import TracksArea from "./TracksArea";
import LeftSidebar from "./LeftSidebar";
import PlaylistsModal from "./PlaylistsModal";
// import BulkEditBar from "./BulkEditBar";

import "./app.scss";

console.log("window.HIFI_APP");
console.log(window.HIFI_APP);

const searchClient = algoliasearch(
  window.HIFI_APP.HIFI_ALGOLIA_APP_ID,
  window.HIFI_APP.HIFI_ALGOLIA_SEARCH_API_KEY
);

/**
 * App.
 */
function App() {
  const heading = "HiFi";
  const editMode = window.HIFI_APP.HIFI_EDIT_MODE;
  return (
    <div className={classNames("app-root", { "edit-mode": editMode })}>
      <InstantSearch
        indexName={window.HIFI_APP.HIFI_ALGOLIA_INDEX_NAME}
        searchClient={searchClient}
      >
        {!editMode && <Configure filters="status:publish" />}
        <PlaylistsModal />
        {/* <BulkEditBar /> */}
        <Header />
        <div className="pagewrap">
          <div className="main-content">
            <LeftSidebar />
            <TracksArea />
          </div>
        </div>
        <ReactTooltip
          effect="solid"
          place="top"
          backgroundColor="#CB3A2E"
          textColor="#ffffff"
          delayShow={300}
          className="hifi-tooltip"
        />
      </InstantSearch>
    </div>
  );
}

setTimeout(() => {
  document.getElementById("hifi-app").classList.add("loaded");
}, 100);

export default App;
